/**
 * Function with simply does nothing on purpose (empty implementation) such that
 * it can be used easily for required function attributes which should not have
 * any side effect.
 */
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const doNothing = (): void => {};
